var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

var isActive = function isActive(percentage) {
  return percentage > 0 && percentage < 99;
};

var Linear = function (_React$Component) {
  _inherits(Linear, _React$Component);

  function Linear() {
    _classCallCheck(this, Linear);

    return _possibleConstructorReturn(this, (Linear.__proto__ || Object.getPrototypeOf(Linear)).apply(this, arguments));
  }

  _createClass(Linear, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'mdc-Progress-linear' },
        React.createElement(
          'div',
          { className: classnames('mdc-Progress-linear-background', {
              'is-active': isActive(this.props.percentage)
            }) },
          React.createElement('div', { className: 'mdc-Progress-linear-inner', style: { width: this.props.percentage + '%' } })
        )
      );
    }
  }]);

  return Linear;
}(React.Component);

Linear.propTypes = {
  percentage: PropTypes.number
};
Linear.defaultProps = {
  percentage: 75
};

var Circular = function (_React$Component2) {
  _inherits(Circular, _React$Component2);

  function Circular() {
    _classCallCheck(this, Circular);

    return _possibleConstructorReturn(this, (Circular.__proto__ || Object.getPrototypeOf(Circular)).apply(this, arguments));
  }

  _createClass(Circular, [{
    key: 'render',
    value: function render() {
      var radius = 30;
      var strokeWidth = 6;
      var length = 2 * Math.PI * 30;
      var size = 2 * radius + strokeWidth;
      var svgSize = '100%';
      var viewBox = '0 0 ' + size + ' ' + size;
      var center = size / 2;
      var style = {
        strokeDasharray: length + ' ' + length,
        strokeDashoffset: length - this.props.percentage * length / 100,
        strokeWidth: strokeWidth
      };
      return React.createElement(
        'svg',
        {
          className: 'mdc-Progress-circular',
          width: svgSize,
          height: svgSize,
          viewBox: viewBox
        },
        React.createElement('circle', {
          style: style,
          className: 'mdc-Progress-circular-path',
          fill: 'none',
          cx: center,
          cy: center,
          r: radius
        })
      );
    }
  }]);

  return Circular;
}(React.Component);

Circular.propTypes = {
  percentage: PropTypes.number
};
Circular.defaultProps = {
  percentage: 0
};


export default { Linear: Linear, Circular: Circular };


//////////////////
// WEBPACK FOOTER
// ../es/js/progress/index.js
// module id = 290
// module chunks = 0